<template>
  <v-data-table
    :headers="headers"
    :items="pickingListItem"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="PickingListItem-button-new"
          @click="$router.push({
            name: 'shop-EditPickingListItem'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'shop-EditPickingListItem',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListPickingListItem',
  module: 'Shop',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('pickingListItem', ['pickingListItem']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('itemCode'),
          value: 'itemCode',
        },
        {
          text: this.$$t('quantity'),
          value: 'quantity',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_pickingListItem();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('pickingListItem', ['LOAD_pickingListItem', 'DELETE_pickingListItem']),
    /** Delete PickingListItem from the collection
     */
    async remove(pickingListItem) {
      this.isLoading = true;
      await this.DELETE_pickingListItem(pickingListItem.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# PickingListItem example

'''js
<PickingListItem />
'''
</docs>
